export default Object.freeze({
  OPEN: 'MarkdownEvent.OPEN'
});
//# sourceMappingURL=MarkdownEvent.js.map